import { $body } from '../Constants';
import HtmlElement from './HtmlElement';

/**
 * MetaBar
 */
const MetaBar = (() => {
  // Constants
  const DATA_KEY = 'ig.meta-bar';
  const EVENT_KEY = `.${DATA_KEY}`;

  /**
   * Selector
   */
  const Selector = {
    META_BAR: '.meta-bar'
  };

  /**
   * MetaBar
   *
   * @class
   * @augments HtmlElement
   */
  class MetaBar extends HtmlElement {}

  return MetaBar._getElement($body.find(Selector.META_BAR), MetaBar);
})();

export default MetaBar;
